export const SURFACE_MCP_ONBOARDING_MODAL_KEY = 'mcpOnboardingModal';
